import { useEffect, useState } from "react";
import { fetchEntities } from "../Requests/components/new-request-modal/utils";
import { eventTypes } from "../EntityCalendar/utils";

const useMyDashboard = () => {
  const [allEntities, setAllEntities] = useState([]);
  const [loading, setloading] = useState(false);
  const [eventDetail, setEventDetail] = useState({});
  const [showEventList, setShowEventList] = useState(true);
  const [isOpen, setIsOpen] = useState(false);

  const fetchEntitiesData = async () => {
    try {
      setloading(true);
      const { data } = await fetchEntities();
      setAllEntities(data);
      setloading(false);
    } catch (error) {
      console.error(error);
      setloading(false);
    } finally {
      setloading(false);
    }
  };
  function transformTaskData(data) {
    return {
      title: data?.name,
      label: data?.serviceName,
      type: eventTypes.EVENT,
      start: new Date(data?.due_date),
      id: data?.milestone,
      status: {
        code: data?.statusData?.code,
        name: data?.statusData?.name,
        primary_color: data?.statusData?.primary_color,
        secondary_color: data?.statusData?.secondary_color,
      },
      end: new Date(data?.due_date),
      color: data?.primary_color,
      process: data?.processId,
      due_date_utc: new Date(data?.due_date),
      entityData: {
        id: data?.entityId,
        name: data?.entityName,
        country: data?.entityCountry,
        timezone: data?.timezone,
      },
      processData: data?.process,
    };
  }

  const handleSelectEvent = (event) => {
    const data = transformTaskData(event);
    setEventDetail(data);
    setShowEventList(false);
  };

  useEffect(() => {
    fetchEntitiesData();
  }, []);
  return {
    allEntities,
    setAllEntities,
    fetchEntitiesData,
    loading,
    showEventList,
    setShowEventList,
    eventDetail,
    setEventDetail,
    isOpen,
    setIsOpen,
    handleSelectEvent,
  };
};

export default useMyDashboard;
